<template>
  <div
    v-if="budgetSummary && budgetSummary.totalBalance > 0"
    class="rounded-lg"
  >
    <div class="text-right">
      <div class="text-xl font-bold">
        ${{ (budgetSummary.totalBalance / 100).toFixed(2) }}
      </div>
      <div class="text-sm text-gray-85">Print Budget Balance</div>
      <div class="text-2xs text-gray-85">
        Available {{ availableUntilText }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { apiGetPrintBudgetSummary, type PrintBudgetSummary } from '~/api/print';
import { parseISO } from 'date-fns';

const props = defineProps<{
  refreshTrigger?: number;
}>();

const loading = ref(false);
const error = ref<string | null>(null);

const { data: budgetSummary } = await useAsyncData('print-budget-summary', () =>
  apiGetPrintBudgetSummary(),
);

const availableUntilText = computed(() => {
  if (!budgetSummary.value?.availableUntil) return '';

  const availableDate = parseISO(budgetSummary.value.availableUntil);

  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  };

  return `until ${availableDate.toLocaleDateString('en-US', options)}`;
});

const fetchBudgetSummary = async () => {
  loading.value = true;
  error.value = null;
  budgetSummary.value = await apiGetPrintBudgetSummary();
  loading.value = false;
};

watch(
  () => props.refreshTrigger,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue !== undefined) {
      fetchBudgetSummary();
    }
  },
);
</script>
